// Shrine ShowMoreButton, adapted to the existing Velio review grid and an editable batch size.
class ShowMoreButton extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    this.button = this.querySelector('button');
    this.status = this.querySelector('[aria-live]');
    this.cards = [...this.closest('.parent-display').querySelector('.parent-wrap').children];
    this.batch = Number(this.dataset.pageSize);
    if (!this.button || !Number.isFinite(this.batch) || this.batch <= 0) return;
    this.shown = this.batch;
    this.button.addEventListener('click', () => this.expandShowMore());
    this.update();
  }
  expandShowMore() {
    const next = this.cards[this.shown];
    this.shown += this.batch;
    this.update();
    if (next) { next.tabIndex = -1; next.focus({preventScroll:true}); }
  }
  update() {
    this.cards.forEach((card,index) => { card.hidden = index >= this.shown; });
    this.button.hidden = this.shown >= this.cards.length;
    this.status.hidden = false;
    this.status.textContent = this.dataset.status.replace('[shown]',Math.min(this.shown,this.cards.length)).replace('[total]',this.cards.length);
  }
}
if (!customElements.get('show-more-button')) customElements.define('show-more-button',ShowMoreButton);
